import React from "react";
import AsyncSelect from "react-select/async";
import { toast } from "react-toastify";
import debounce from "debounce-promise";

import apiClient from "../../../../application/apis/api-client";
import {
  isNotFoundError,
  isPermissionError,
  reportProcManagementRelatedError,
} from "../../../../application/domain/proc-management/util/error";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputProps, PathProps } from "./types";
import { ProcedureTagBaseInfo } from "../../../../application/domain/proc-management";

type Props = {
  id: string;
  name: string;
  orgId: string;
  errorMsg?: string;
  selectedTags: ProcedureTagBaseInfo[];
} & InputProps &
  PathProps;

type OptionType = {
  label: string;
  value: string;
};

export const TagInputForProc: React.FC<Props> = ({
  id,
  name,
  basePath,
  orgId,
  onChange,
  shouldDisplayError = false,
  selectedTags,
  errorMsg,
  disabled = false,
}) => {
  const isError = errorMsg && errorMsg !== "";
  const currentTag: OptionType = { label: name, value: id };
  const loadOptions = debounce(async (input: string) => {
    try {
      const { data: tags } = await apiClient.procManagement.listProcedureTags({
        organizationId: orgId,
        query: input,
      });
      return tags.items
        .filter((t) => {
          const checkTagArray = selectedTags.map((t) => t.name);
          return !checkTagArray.includes(t.name);
        })
        .map((t) => {
          const opt: OptionType = {
            label: t.name,
            value: t.id,
          };
          return opt;
        });
    } catch (e) {
      reportProcManagementRelatedError(e);
      if (isNotFoundError(e)) {
        toast.error(`手続きタグを見つけることができませんでした。`);
      } else if (isPermissionError(e)) {
        toast.error(`手続きタグを表示する権限がありません。`);
      } else {
        toast.error(
          `手続きタグの取得に失敗しました。電波状況のよい場所でリロードしてください。`,
        );
      }
      return [];
    }
  }, 500);
  return (
    <div>
      <div className="mb-2">
        <FormFieldLabel label="タグ" bold={false} required />
        <AsyncSelect
          placeholder={"選択してください"}
          value={currentTag}
          onChange={(opt) => {
            if (opt && opt.value) {
              onChange([...basePath, "id"], opt.value);
              onChange([...basePath, "name"], opt.label);
            }
          }}
          defaultOptions
          loadOptions={loadOptions}
          isDisabled={disabled}
        />
        {isError && shouldDisplayError && (
          <p className="help has-text-weight-normal is-danger">{errorMsg}</p>
        )}
      </div>
    </div>
  );
};
